<div class="shop-container">
    <div class="shop-wrapper" *ngIf="!loading">
      
        <div class="shop-header">
            <div class="header-text">
                <h1 class="shop-title">Our Flight Plans</h1>
                <p class="shop-subtitle">Explore our curated tests, mentorship & prep kits</p>
            </div>


            <div class="search-container">
                <span class="p-input-icon-left p-input-icon-right w-full block">
                    <i class="pi pi-search"></i>
                    <input type="text" class="w-full" placeholder="Search courses..." [value]="searchQuery"
                        (input)="onSearch($event)" />
                    <i *ngIf="searchLoading" class="pi pi-spinner pi-spin"></i>
                </span>

                <div class="search-suggestions" *ngIf="showSuggestions && searchQuery.length >= 3">
                    <div class="suggestion-item text-gray-500 italic p-3 text-center" *ngIf="searchLoading">
                        Searching...
                    </div>
                    <div class="suggestion-item text-gray-500 italic p-3 text-center"
                        *ngIf="!searchLoading && searchSuggestions.length === 0">
                        No courses found
                    </div>
                    <ng-container *ngIf="!searchLoading && searchSuggestions.length > 0">
                        <div class="suggestion-item p-3 border-bottom-1 border-gray-200 cursor-pointer hover:bg-gray-50 transition-colors"
                            *ngFor="let suggestion of searchSuggestions | slice:0:5"
                            (click)="selectSuggestion(suggestion)">
                            <div class="font-medium text-gray-900">{{ suggestion.name }}</div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="controls-container">
            <div class="tabs-container">
                <button *ngFor="let cat of categories" (click)="setCategory(cat)" class="tab-pill"
                    [class.active]="activeCategory === cat">
                    {{ cat }}
                </button>
            </div>
        </div>

        <div>
            <div class="packages-grid">
                <div *ngFor="let pkg of paginatedPackages" class="package-card">
                    <div class="card-content">
                        <div class="badge-wrapper flex flex-wrap gap-2" *ngIf="pkg.categories && pkg.categories.length > 0">
                            <span class="category-badge" *ngFor="let cat of pkg.categories"
                                [ngClass]="cat === 1 || cat === 2 ? 'badge-green' : 'badge-blue'">
                                {{ categoryMap[cat] || 'Other' }}
                            </span>
                        </div>

                        <div class="card-header-row">
                            <div class="icon-box">
                                {{ getIcon(pkg) }}
                            </div>
                            <div class="title-box">
                                <h3 class="pkg-title">{{ pkg.name }}</h3>
                            </div>
                        </div>

                        <div class="pkg-desc custom-html-content"
                            [class.desc-collapsed]="!isFeaturesExpanded(pkg.id) && needsReadMore(pkg)"
                            [innerHTML]="pkg.description || 'India\'s most comprehensive career psychometric evaluation'">
                        </div>

                        <ng-container *ngIf="isFeaturesExpanded(pkg.id) || !needsReadMore(pkg)">
                            <ul class="features-list">
                                <li *ngFor="let feature of getFeatures(pkg)">
                                    <i class="pi pi-check-circle feature-icon"></i>
                                    <span class="feature-text">{{ feature }}</span>
                                </li>
                            </ul>

                            
                            <div style="margin-top: 12px;" *ngIf="needsReadMore(pkg)">
                                <span class="read-more-btn" (click)="toggleFeatures(pkg.id)">
                                    Read Less
                                </span>
                            </div>
                        </ng-container>

                        <div style="margin-top: 8px;" *ngIf="!isFeaturesExpanded(pkg.id) && needsReadMore(pkg)">
                            <span class="read-more-btn" (click)="toggleFeatures(pkg.id)">
                                Read More
                            </span>
                        </div>
                    </div>

                    <div class="card-footer">
                        <div class="cta-group">
                            <button class="enquire-now-btn" (click)="enquireNow()">
                                Enquire Now
                            </button>
                            <button class="talk-expert-btn" (click)="talkToExpert()">
                                Talk to an Expert <i class="pi pi-whatsapp ml-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="filteredPackages.length === 0" class="empty-state">
                No packages found in this category.
            </div>

            <div class="pagination-container" *ngIf="totalPages > 1">
                <button class="nav-btn" [disabled]="currentPage === 1" (click)="prevPage()">
                    <i class="pi pi-angle-left"></i> Previous
                </button>

                <div class="page-numbers">
                    <button *ngFor="let page of getPageNumbers()" class="page-btn" [class.active]="currentPage === page"
                        (click)="goToPage(page)">
                        {{ page }}
                    </button>
                </div>

                <button class="nav-btn" [disabled]="currentPage === totalPages" (click)="nextPage()">
                    Next <i class="pi pi-angle-right"></i>
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="loading" class="w-full flex align-items-center justify-content-center p-5 min-h-screen">
        <p-progressSpinner></p-progressSpinner>
    </div>
</div>